/*
 * File: studentViewReport.js
 * Project: educore
 * Created Date: 2019-01-09
 * Author: Raziya S
 *
 */
class StudentViewReport {
    // @ngInject
    constructor($state, $rootScope, $scope, $mdMedia, $filter, $mdDialog, localStorageService, authService, activityCons, $stateParams, SchoolLogo, CONSTANTS) {

        let qpId = $stateParams.qpId
        let studentId = $stateParams.studentId
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }

        $scope.isLoading = true
        //[Object] - dataset for wave details
        $scope.waveDetails = [];

        //[Object] - dataset for level details
        $scope.levelDetails = [];

        //[Object] - dataset for tag
        $scope.tagDetails = [];

        //[String] - List of tags label
        $scope.tagLabel = [];

        //[Object] - Contains chart data
        $scope.chartArray = []

        //Number - To set width of chart
        $scope.chartWidth = 610;

        //Number - To set height of chart
        $scope.chartHeight = 350;

        //[Object] - Holds list of chart details
        $scope.chartImgData = []

        $scope.colorArray = ['#3366cc', '#109618', '#f44336']

        /*
         * Function to get assigned users
         * 
         * @qpId : String - Id of the question paper
         * 
         *
         */
        authService.callAPI(activityCons.API_STUDENT_REPORT + qpId + '/' + studentId, "GET", {}, function(response) {
            console.log(response)
            if (response && response.result && response.result.data) {
                let resultData = response.result.data
                console.log(resultData.basicDetails)
                if(resultData.basicDetails)
                {
                    $scope.studentName = resultData.basicDetails.studentName
                    $scope.examTitle = resultData.basicDetails.examTitle
                    $scope.isLoading = false
                }
                if (resultData.graphDetails && resultData.graphDetails.length > 0) {
                    if (resultData.graphDetails && resultData.graphDetails.length > 0) {
                        if (resultData.graphDetails[0].questionDetail && resultData.graphDetails[0].questionDetail) {
                            if (resultData.graphDetails[0].questionDetail.length > 0) {
                                let questionDetails = resultData.graphDetails[0].questionDetail[0]
                                let values = []
                                let header = []
                                header.push("Activity")
                                header.push("Total Questions")
                                header.push("No. of Correct Answers")
                                header.push("No. of Wrong Answers")
                                values.push(header)
                                let wrongAnswer = questionDetails.total_question - questionDetails.correct_answer

                                let arr = []
                                arr.push("")
                                arr.push(questionDetails.total_question)
                                arr.push(questionDetails.correct_answer)
                                arr.push(wrongAnswer)
                                values.push(arr)

                                $scope.quesObj = {
                                    'key': "activity",
                                    'graph': "Bar",
                                    'title': "Activity" + '  vs  ' + "Questions",
                                    'value': values
                                }
                                $scope.chartArray.push($scope.quesObj)
                                
                            }
                        }
                        if (resultData.graphDetails[0].waveDetails && resultData.graphDetails[0].waveDetails) {
                            if (resultData.graphDetails[0].waveDetails.length > 0) {
                                let waveDetails = resultData.graphDetails[0].waveDetails
                                let values = []
                                let header = []
                                header.push("Wave")
                                header.push("Total Questions")
                                header.push("No. of Correct Answers")
                                //header.push("No. of Wrong Answers")
                                values.push(header)
                                _.each(waveDetails, function(data) {
                                    let arr = []
                                    arr.push(data.wave.wave)
                                    arr.push(data.activity[0].total_questions)
                                    arr.push(data.activity[0].correct_answer)
                                    //let wrongAnswer = data.activity[0].total_questions - data.activity[0].correct_answer
                                    //arr.push(wrongAnswer)
                                    values.push(arr)
                                })
                                $scope.tagObj = {
                                    'key': "wave",
                                    'graph': "Bar",
                                    'title': "Wave" + '  vs  ' + "Count",
                                    'value': values
                                }
                                $scope.chartArray.push($scope.tagObj)
                               
                            }
                        }
                        if (resultData.graphDetails[0].tagDetails && resultData.graphDetails[0].tagDetails) {
                            if (resultData.graphDetails[0].tagDetails.length > 0) {
                                let tagDetails = resultData.graphDetails[0].tagDetails
                                let values = []
                                let header = []
                                header.push("Tag")
                                header.push("Total Questions")
                                header.push("No. of Correct Answers")
                                //header.push("No. of Wrong Answers")
                                values.push(header)
                                _.each(tagDetails, function(data) {
                                    let arr = []
                                    arr.push(data._id)
                                    arr.push(data.activity[0].total_questions)
                                    arr.push(data.activity[0].correct_answer)
                                    //let wrongAnswer = data.activity[0].total_questions - data.activity[0].correct_answer
                                    //arr.push(wrongAnswer)
                                    values.push(arr)
                                })
                                $scope.tagObj = {
                                    'key': "tag",
                                    'graph': "Bar",
                                    'title': "Tag" + '  vs  ' + "Count",
                                    'value': values
                                }
                                $scope.chartArray.push($scope.tagObj)
                                
                            }
                        }
                        if (resultData.graphDetails[0].levelDetails && resultData.graphDetails[0].levelDetails) {
                            if (resultData.graphDetails[0].levelDetails.length > 0) {
                                let levelDetails = resultData.graphDetails[0].levelDetails
                                let values = []
                                let header = []
                                header.push("Level")
                                header.push("Total Questions")
                                header.push("No. of Correct Answers")
                                //header.push("No. of Wrong Answers")
                                values.push(header)
                                _.each(levelDetails, function(data) {
                                    let arr = []
                                    arr.push(data.level.level)
                                    arr.push(data.activity[0].total_questions)
                                    arr.push(data.activity[0].correct_answer)
                                    //let wrongAnswer = data.activity[0].total_questions - data.activity[0].correct_answer
                                    //arr.push(wrongAnswer)
                                    values.push(arr)
                                })
                                $scope.tagObj = {
                                    'key': "level",
                                    'graph': "Bar",
                                    'title': "Level" + '  vs  ' + "Count",
                                    'value': values
                                }
                                $scope.chartArray.push($scope.tagObj)
                                
                            }
                        }
                    }
                }

            } else {
               // toastr.error('Network Error. Please try later');
            }
            _.defer(function() {
                $scope.$apply();
            });
        });


        //Object - details of tp and student
        let details = {
            studentId: $stateParams.studentId,
            tpId: $stateParams.planId
        }
        $scope.barOptions = {
            responsive: true,
            maintainAspectRatio: true,
            scaleBeginAtZero: true,
            scaleShowGridLines: false,
            barValueSpacing: 1,
            barDatasetSpacing: 1,
            tooltipEvents: ["mousemove", "mouseout", "click", "touchstart", "touchmove", "touchend"],
            legend: {
                display: false,
            },
            scales: {
                xAxes: [{
                    barPercentage: 0.9,
                    categoryPercentage: 0.5
                }],
                yAxes: [{
                    ticks: {
                        stepSize: 1,
                        beginAtZero: true // minimum value will be 0.
                    }
                }]
            },
        }

        /*
         * Function to go back to activity page
         *
         * @return - null
         *
         */
        $scope.goBack = () => {
            let params = $stateParams.prevParams;
            $state.go("wizard.activityReport", params)
        }

        function convertFileToDataURLviaFileReader(url, callback) {
            var xhr = new XMLHttpRequest();
            xhr.onload = function() {
                var reader = new FileReader();
                reader.onloadend = function() {
                    callback(reader.result);
                }
                reader.readAsDataURL(xhr.response);
            };
            xhr.open('GET', url);
            xhr.responseType = 'blob';
            xhr.send();
        };

        /*
         * To get chart details from Child chart component
         * 
         * @data : Object - Chart details
         * 
         * @return : null
         */
        $scope.getChartData = function(data) {
            if (data != undefined && data[0] != undefined) {
                $scope.chartImgData.push(data[0])
            }
        }

        /*
         * To export chart as PDF file
         * 
         * @return : null
         */
        $scope.exportAsPDF = function() {
            var doc = new jsPDF('p', 'pt', 'a4', false) /* Creates a new Document*/
            doc.addImage($scope.imgurl1, 'png', 50, 30, 70, 70, undefined, 'none');
            doc.setFontSize(18);
            doc.setFontType('bold');
            var xOffset = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth($scope.schoolHeader.schoolName) * doc.internal.getFontSize() / 2);
            doc.text(xOffset, 50, $scope.schoolHeader.schoolName);
            doc.setFontSize(12);
            doc.setFontType('normal');
            doc.text(230, 70, 'Academic Year : ' + $scope.schoolHeader.academicYear);
            doc.setFontSize(16);
            doc.text(220, 90, 'Student Based Report');
            doc.setFontSize(15); /* Define font size for the document */
            var yAxis = 150;

            for (var i = 0; i < $scope.chartImgData.length; i++) {
                if (i % 2 == 0 && i != 0) { /* I want only two images in a page */
                    doc.addPage(); /* Adds a new page*/
                    yAxis = 30; /* Re-initializes the value of yAxis for newly added page*/
                }

                var width = doc.internal.pageSize.width; //$scope.imageTags[i].width;
                var height = $scope.chartImgData[i].height - 100; //doc.internal.pageSize.height;

                if (doc.internal.pageSize.width <= $scope.chartImgData[i].width) {
                    width = doc.internal.pageSize.width;
                } else {
                    width = $scope.chartImgData[i].width;
                }

                height = $scope.chartImgData[i].height * width / doc.internal.pageSize.width;
                height = width * (3 / 4) - 100

                var someText = (i + 1) + ".) " + $scope.chartImgData[i].title;
                doc.text(60, yAxis, someText); /* Add some text in the PDF */
                yAxis = yAxis + 20; /* Update yAxis */
                //doc.addImage($scope.imageTags[i].image, 'png', 40, yAxis, 530, 350, undefined, 'none');
                doc.addImage($scope.chartImgData[i].image, 'png', 0, yAxis, width, height, undefined, 'none');
                yAxis = yAxis + 360; /* Update yAxis */
            }
            window.open(doc.output('bloburl'))
                // window.open(encodeURI('https://docs.google.com/gview?embedded=true&url='+url), '_blank', 'location=yes,EnableViewPortScale=yes');
                // doc.save('Student_Based_Report.pdf')
        }


    }
}

export default StudentViewReport



// WEBPACK FOOTER //
// ./src/app/traditionalActivity/controllers/studentViewReport.js